import {etsySettings} from '@coolcolduk/etsy';
import {z} from 'zod';

export const zEtsyTag = z.string().max(etsySettings.listing.tags.maxLength);
